import { NgModule, InjectionToken } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy, RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { IonicStorageModule } from "@ionic/storage-angular";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { HttpClientModule } from "@angular/common/http";
import { FIREBASE_OPTIONS } from '@angular/fire/compat';

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { environment } from "../environments/environment";
// import { Deploy } from "cordova-plugin-ionic/dist/ngx";

import { AngularFireStorageModule } from "@angular/fire/compat/storage";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { AngularFireDatabaseModule } from "@angular/fire/compat/database";
import { ToastrModule } from "ngx-toastr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ServiceWorkerModule } from "@angular/service-worker";
import { NgSelectModule } from "@ng-select/ng-select";

import { PromptComponent } from "./components/prompt/prompt.component";
// import { GuidedTourModule, GuidedTourService } from "ngx-guided-tour";

import { AngularFireModule } from "@angular/fire/compat";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { provideFirebaseApp, initializeApp, getApp } from "@angular/fire/app";


@NgModule({
  declarations: [AppComponent, PromptComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    // AngularFireModule debe ir primero para inicializar Firebase
    AngularFireModule.initializeApp(environment.firebase),
    RouterModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    // GuidedTourModule.forRoot(),
    NgSelectModule,
    NgxDatatableModule,
    ToastrModule.forRoot({
      positionClass: "toast-bottom-center",
      preventDuplicates: true,
      timeOut: 2000,
      progressBar: true,
    }),
    HttpClientModule,
    // IonicStorageModule.forRoot(),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    // Inicializar la nueva API de Firebase para Analytics
    // Nota: AngularFireModule inicializa Firebase con la API legacy,
    // pero necesitamos la nueva API para Analytics
    provideFirebaseApp(() => {
      try {
        // Intentar obtener la app existente
        return getApp();
      } catch {
        // Si no existe, inicializarla (puede haber conflicto con AngularFireModule)
        return initializeApp(environment.firebase);
      }
    }),
    AngularFireAuthModule,
    AngularFirestoreModule.enablePersistence(),
    AngularFireStorageModule,
    AngularFireDatabaseModule,
  ],
  providers: [
    // GuidedTourService,
    // Deploy, // Comentado porque requiere JIT compilation - se manejará de forma opcional
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}